import { defaultStorageKeyBuilder } from "../store/defaultStorageKeyBuilder.js";
import { AsyncResource } from "./AsyncResource.js";
import { asyncResourceStore } from "./store.js";
const emptyResource = new AsyncResource(() => Promise.resolve(undefined));
export function getAsyncResource(asyncFn, parameters, options = {}) {
    const { loaderId, tags } = options;
    if (parameters === null) {
        return emptyResource;
    }
    const storageKey = defaultStorageKeyBuilder({
        asyncFn,
        parameters,
        loaderId,
    });
    const asyncResourceLoader = () => asyncFn(...parameters);
    const resourceBuilder = () => new AsyncResource(asyncResourceLoader);
    return asyncResourceStore.getOrSet(storageKey, resourceBuilder, {
        tags: tags,
    });
}
